import { Box, Stack, Typography } from '@mui/material';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { useBreakpoints } from 'shared';

import { scrollingTextItems } from './constants';

export const ScrollingText = () => {
  const { isDownSmLayout } = useBreakpoints();

  return (
    <Stack mt={{ xs: '113px', md: '151px' }} gap={3}>
      <Typography variant="h4" textAlign={{ xs: 'center', sm: 'left' }} fontSize={16} className="secondary">
        12+1 Game-Changing Applications:
      </Typography>
      <Box
        mx={{ xs: -2.5, sm: 0 }}
        width={{ xs: '100vw', sm: '100%', md: 'min(calc(1340px - 429px - 40px), calc(100vw - 429px - 40px))' }}
        overflow="hidden"
        position="relative"
        height={37}
      >
        <Splide
          options={{
            gap: 48,
            pagination: false,
            omitEnd: true,
            type: 'loop',
            arrows: false,
            drag: false,
            focus: 'center',
            perPage: isDownSmLayout ? 3 : 6,
            height: 37,
            autoScroll: {
              speed: 1,
            },
            autoWidth: true,
          }}
          extensions={{ AutoScroll }}
        >
          {scrollingTextItems.map((text) => (
            <SplideSlide key={text}>
              <Stack justifyContent="center" height="100%">
                <Typography className="white" fontSize={20} lineHeight="125%">
                  {text}
                </Typography>
              </Stack>
            </SplideSlide>
          ))}
        </Splide>
        <Box
          sx={{
            background: 'transparent',
            position: 'absolute',
            width: '100%',
            height: 37,
            top: 0,
            zIndex: 2,
          }}
        />
      </Box>
    </Stack>
  );
};
